import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onUnmounted, nextTick } from 'vue';
  

export default /*#__PURE__*/_defineComponent({
  __name: 'LockDialog',
  setup(__props, { expose }) {
 
const lock_dialog = ref();
let observer = null;
let observer1 = null; 

const lockDialog=()=>{
  // console.log('lockDialog called');
  
  // 如果已经有observer，先断开
  if (observer) {
    observer.disconnect();
  }

   if (observer1) {
    observer1.disconnect();
  }
 
  
  // 当事情发生变化时调用`update`
  observer = new MutationObserver((mutations)=>{
    // console.log('Mutations detected:', mutations.length);
    console.log(mutations)
    if(mutations.length > 0){
      //location.reload(); // 刷新页面
      mutations.forEach((mutation) => {
         if(mutation.type === 'childList') {
           if(mutation.removedNodes.length > 0) { 
              location.reload(); // 刷新页面
           }
         }
            console.log(mutation);
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            
            if(mutation.target !== null){
                location.reload(); // 刷新页面
            }
        }
      })

    }  
    
    // mutations.forEach((mutation) => {
    //   console.log('Mutation type:', mutation.type, 'target:', mutation.target, 'removedNodes:', mutation.removedNodes);
    //   if (mutation.type === 'childList') {
    //     mutation.removedNodes.forEach((node) => {
    //       console.log('Removed node:', node);
    //       if (node.nodeType === Node.ELEMENT_NODE) {
    //         const element = node as Element;
    //         console.log('Element classList:', element.classList, 'closest .el-dialog:', element.closest('.el-dialog'));
    //         if (element.closest('.el-dialog') || element.classList.contains('el-dialog') || element.classList.contains('el-overlay')) {
    //           console.log('提示：el-dialog的DOM元素或其子元素被删除');

              
    //         }
    //       }
    //     });
    //   }
    // });
  });

  
     // 观察lock_dialog子元素的变化
        observer.observe(lock_dialog.value, {
            childList: true,
            subtree: false, // 监听子孙节点变化，包含slot内容
            attributes: true,  
            attributeFilter: ['class', 'style']   // 只监听特定属性
        });  


  observer1 = new MutationObserver((mutations)=>{
    // console.log('Mutations detected:', mutations.length);
    // console.log(mutations)
     mutations.forEach((mutation) => {
         if(mutation.type === 'childList') {
           if(mutation.removedNodes.length > 0) { 
              location.reload(); // 刷新页面
           }
         }
            console.log(mutation);

          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            if(mutation.target !== null){
                location.reload(); // 刷新页面
            }
        }
      })
  })

  // 观察lock_dialog父节点下的子节点变化和属性变化
  observer1.observe(lock_dialog.value.parentNode, {
    childList: true,   
    subtree: false, // 监听父节点下的所有子孙节点
    attributes: true,   
    attributeFilter: ['class', 'style']   // 只监听特定属性
  }); 
  
} 

onMounted(() => {
  console.log('LockDialog mounted');
//   lockDialog();
});

expose({
  lock: ()=>{
    setTimeout(()=>{

        lockDialog();
    },1000)
    
  }  
})

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
  if (observer1) {
    observer1.disconnect();
  }
 
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "lock_dialog",
    ref: lock_dialog,
    class: "lock_dialog"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})